"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Progress = void 0;

var react_1 = __importDefault(require("react"));

var prop_types_1 = __importDefault(require("prop-types"));

require("./template-3-progress.scss");

function Progress(_ref) {
  var badgeText = _ref.badgeText,
      colorClass = _ref.colorClass,
      title = _ref.title,
      content = _ref.content,
      imageUrl = _ref.imageUrl,
      className = _ref.className,
      link = _ref.link,
      linkText = _ref.linkText;
  return react_1.default.createElement("div", {
    className: "flex relative"
  }, react_1.default.createElement("div", {
    className: "w-full md:flex flex-wrap justify-center mb-8 flex-wrap progress ".concat(className.wrapper)
  }, react_1.default.createElement("div", {
    className: "md:w-2/5 md:mr-16"
  }, react_1.default.createElement("img", {
    src: imageUrl,
    alt: "process",
    className: "mx-auto"
  })), react_1.default.createElement("div", {
    className: "md:w-1/2"
  }, react_1.default.createElement("div", {
    className: "flex max-w-7xl w-full mx-auto mt-40px lg:mt-0 flex-wrap content ".concat(className.rightWrapper)
  }, react_1.default.createElement("div", {
    className: className === null || className === void 0 ? void 0 : className.fakeImageWrapper
  }), react_1.default.createElement("div", {
    className: "w-full lg:pl-53px flex flex-col  justify-center max-w-lg mx-auto ".concat(className === null || className === void 0 ? void 0 : className.contentWrapper)
  }, react_1.default.createElement("div", {
    className: "flex"
  }, badgeText && react_1.default.createElement("div", {
    className: "w-48px h-48px sm:w-68px sm:h-68px font-16px sm:font-24px mt-40px text-sm ".concat(colorClass, " flex text-center items-center badge justify-center ").concat(className === null || className === void 0 ? void 0 : className.badge)
  }, badgeText)), react_1.default.createElement("div", {
    className: "block mt-4 font-bold font-18px sm:font-20px mt-22px sm:mt-30px text-sm ".concat(className === null || className === void 0 ? void 0 : className.title)
  }, title), react_1.default.createElement("div", {
    className: "block mt-4 text-sm font-14px mt-13px sm:mt-11px leading-7 content ".concat(className === null || className === void 0 ? void 0 : className.content)
  }, content), link && react_1.default.createElement("a", {
    className: "link ".concat(className === null || className === void 0 ? void 0 : className.link),
    href: link
  }, linkText !== null && linkText !== void 0 ? linkText : react_1.default.createElement("span", {
    className: "flex link-text ".concat(className === null || className === void 0 ? void 0 : className.linkText)
  }, "Read More ", react_1.default.createElement("svg", {
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, react_1.default.createElement("path", {
    d: "M-0.000155798 8.91984L-0.000155623 6.91984L11.9998 6.91984L6.49984 1.41984L7.91985 -0.000157095L15.8398 7.91984L7.91984 15.8398L6.49984 14.4198L11.9998 8.91984L-0.000155798 8.91984Z",
    fill: "#111111"
  })))))))));
}

exports.Progress = Progress;
;
Progress.propTypes = {
  badgeText: prop_types_1.default.string,
  colorClass: prop_types_1.default.string,
  title: prop_types_1.default.string,
  content: prop_types_1.default.oneOfType([prop_types_1.default.string, prop_types_1.default.object]),
  imageUrl: prop_types_1.default.oneOfType([prop_types_1.default.string, prop_types_1.default.object]),
  className: prop_types_1.default.object,
  linkText: prop_types_1.default.string,
  link: prop_types_1.default.string
};
Progress.defaultProps = {
  badgeText: '01',
  colorClass: 'bg-color-default',
  title: 'When to Use Lorem Ipsum',
  imageUrl: 'https://upload.wikimedia.org/wikipedia/vi/b/b0/Avatar-Teaser-Poster.jpg',
  content: "There was that time artists at Sequence opted to hand-Sharpie the lorem ipsum passage on a line of paper bags they designed for Chipotle\u2014the result being a mixture of avant-garde, inside.\nThose with an eye for detail may have caught a tribute to the classic text in an episode of Mad Men (S6E1 around 1:18:55 for anyone that didn't). And here is a lorem ipsum tattoo.",
  className: {
    rightWrapper: "",
    contentWrapper: "",
    wrapper: "",
    badge: "",
    displayLine: "",
    title: "",
    img: "",
    fakeImageWrapper: "w-full lg:w-1/2 max-w-lg",
    content: "",
    link: "mt-20px xl:mt-27px",
    linkText: ""
  },
  link: null
};